import React from "react";
import { Avatar, PresenceBadgeProps } from "@fluentui/react-components";
import { ContactType } from "@/repository/models";
import { useLazyUserPhoto } from "@/hooks/userPhoto/useLazyUserPhoto";

interface ContactAvatarProps {
	id: string;
	name: string;
	contactType: ContactType;
	badge?: PresenceBadgeProps;
	className?: string;
}

export const ContactAvatar = ({ id, name, contactType, badge, className }: ContactAvatarProps) => {
	const { ref, image } = useLazyUserPhoto(id, contactType === ContactType.AzureActiveDirectory);

	return (
		<Avatar
			ref={ref as React.Ref<HTMLElement>}
			name={name}
			image={image}
			badge={badge}
			className={className}
		/>
	);
};
